export const createAmazonLink = (input) => {
  if (input.startsWith("http")) return input;
  const encoded = encodeURIComponent(input).replace(/%20/g, '+');
  return `https://www.amazon.co.jp/s?k=${encoded}`;
};
